<template>
  <div id="app" :class="ml">
    <router-view />
  </div>
</template>

<script>
// import { getToken, getStatus } from "@/proxy/index";

export default {
  data() {
    return {
      showBack: true,
      ml: false,
      lan: "",
    };
  },
  watch: {
    $route: {
      handler: function (search) {
        let path = this.$route.path;
        this.lan = window.localStorage.getItem("Creatorlang") || "";
        if (
          path == "/home" ||
          path == "/activity" ||
          path == "/tutorials"
        ) {
          this.ml = "ml";
          if (this.lan == "ar") {
            this.ml = "ml ar";
          }
        } else {
          this.ml = "";
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    // 获取url参数
    getUrlParam: function (variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    resolveParams(params) {
      try {
        const locaitonSearch = params.replace(/%3D/g, "=");
        var x = this.b64DecodeUnicode(locaitonSearch);
        var arry = x.split("&");

        for (var i = 0; i < arry.length; i++) {
          var index = arry[i].indexOf("=");
          var key = arry[i].slice(0, index);
          var val = arry[i].slice(index + 1);
          this.linkInfo[key] = val;
        }
      } catch (error) {
        console.log(error);
      }
      return this.linkInfo;
    },
    // url解码
    b64DecodeUnicode: function (str) {
      return decodeURIComponent(
        atob(str)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/public.scss";
body a {
  -webkit-tap-highlight-color: transparent;
  text-decoration: none;
}

html,
body {
  width: 100%;
  height: 100%;
  font-family: "\5FAE\8F6F\96C5\9ED1";
  overflow-x: hidden;
  margin: 0;
  position: relative;
  -webkit-text-size-adjust: 100%;
  background-color: #042442;
}
.removeClickBg {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
#app {
  position: relative;
  width: 100%;
  background: url("./assets/images/bg1.jpg") top repeat;
  background-size: 100% auto;
}
.nav {
  ul {
    li {
      background: url("./assets/images/nav-bg.png") center no-repeat;
      background-size: 100% 100%;
      @include ft(24);
      color: #7fbfff;
      width: 100%;

      a {
        width: 100%;
        height: 100%;
        color: #7fbfff;
        display: inline-block;
      }

      &.active {
        background: url("./assets/images/nav-active.png") center repeat;
        background-size: 100% 100%;
      }
    }
  }
}
@media screen and (orientation: landscape) {
  #app {
    background: url("./assets/images/bg1.jpg") top repeat;
    background-size: 100% 100%;
  }
  #app {
    &.ml {
      width: len2(1146);
      margin-left: len2(188);
    }
    &.ar {
      margin-left: 0;
      width: len2(1146);
      margin-right: len2(188);
    }
  }
  //横板
  .nav {
    position: fixed;
    top: 0;
    left: 0;
    text-align: center;
    width: len2(188);
    height: 100%;
    background: url("./assets/images/nav.png") center no-repeat;
    background-size: 100% 100%;
    &.ar {
      right: 0;
      left: 100%;
      transform: translateX(-100%);
    }
    ul {
      height: 100%;
      width: 100%;
      position: relative;
      li {
        display: inline-block;
        box-sizing: border-box;
        width: 100%;
        height: len2(102);
        line-height: len2(102);
      }
      .back {
        display: block;
        @include wh(0, 86);

        img {
          @include wh(102, 84);
        }
        margin: auto;
      }

      .join {
        height: auto;
        line-height: normal;
        @include pd(15, 0);
        position: absolute;
        left: 0;
        bottom: 0;
        background: none;

        img {
          margin: auto;
          @include wh(110, 110);
        }
        p {
          margin-top: len2(-15);
          width: 100%;
        }
      }
    }
  }
}

@media screen and (orientation: portrait) {
   #app {
    background: url("./assets/images/bg2.jpg") top repeat;
    background-size: 100% 100%;
  }
  //竖版
  .nav {
    position: fixed;
    bottom: 0;
    left: 0;
    text-align: center;
    width: 100%;
    height: len(97);
    line-height: len(97);
    z-index: 4;
    background-color: #122b50;
    color: #fff;
    ul {
      height: 100%;
      width: 100%;
      li {
        display: inline-block;
        box-sizing: border-box;
        width: 33.3%;
        height: 100%;
        border-top: 1px solid;
        border-left: 2px solid;
        border-image: radial-gradient(
            circle,
            rgba(189, 217, 254, 1),
            rgba(23, 52, 97, 0)
          )
          2 2;
      }
      .back {
        display: none;
      }
    }
  }
}
</style>

